module.exports = __webpack_public_path__ + "static/media/banner-ano-novo.9447db2f.png";